// React
import React from 'react';

// Packages
import t from 'prop-types';

const VideoComponent = ({ id, title }) => {
    // ///////////////////
    // RENDER
    // ///////////////////

    // Youtube: src={`https://www.youtube.com/embed/${id}?rel=0&modestbranding=1&color=white`}

    return (
        <div className="overflow-hidden shadow-sm aspect-video rounded-8">
            <iframe
                className="w-full h-full"
                src={`https://www.loom.com/embed/${id}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={title}
            />
        </div>
    );
};

VideoComponent.propTypes = {
    id: t.string.isRequired,
    title: t.string.isRequired,
};

VideoComponent.defaultProps = {
    id: '',
    title: '',
};

export default VideoComponent;
